import { render, staticRenderFns } from "./KozigSearch.vue?vue&type=template&id=40f04e17&scoped=true&"
import script from "./KozigSearch.vue?vue&type=script&lang=js&"
export * from "./KozigSearch.vue?vue&type=script&lang=js&"
import style0 from "./KozigSearch.vue?vue&type=style&index=0&id=40f04e17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f04e17",
  null
  
)

export default component.exports